export function statusLabelColor(status) {
  let statusColor, statusBackgroundColor;

  if (status === "processed") {
    statusColor = "#23D020";
    statusBackgroundColor = "rgba(4, 201, 0, 0.1)";
  } else if (status === "processing") {
    statusColor = "#848696";
    statusBackgroundColor = "rgba(151, 151, 151, 0.15)";
  }

  return { statusColor, statusBackgroundColor };
}

export function patientBoardItemStatus(status) {
  let statusColor, statusBackgroundColor;

  if (status === "processed") {
    statusColor = "#23D020";
    statusBackgroundColor = "rgba(4, 201, 0, 0.1)";
  } else if (status === "processing") {
    statusColor = "#848696";
    statusBackgroundColor = "rgba(151, 151, 151, 0.15)";
  } else {
    statusColor = "#E52323";
    statusBackgroundColor = "#FF000014";
  }

  return { statusColor, statusBackgroundColor };
}

export function activityStatusLabelColor(status) {
  let statusColor, statusBackgroundColor;

  if (status === "pending") {
    statusBackgroundColor = "rgba(236, 148, 44, 0.15)";
    statusColor = "#EC942C";
  } else if (status === "done" || status === "accepted") {
    statusBackgroundColor = "rgba(4, 201, 0, 0.1)";
    statusColor = "#04C900";
  } else if (status === "processing") {
    statusBackgroundColor = "rgba(151, 151, 151, 0.15)";
    statusColor = "#848696";
  }
  return { statusColor, statusBackgroundColor };
}
